export default {
  name: "Notice",
  props: {
    type: {
      type: String,
      default() {
        return "USER";
      }
    }
  }
};